<template>
    <div class="w-full h-[64vw] relative overflow-hidden">
        <img src="../../assets/img/Desktop/StartJourney/Frame 74.webp" alt="" class="w-full h-auto translate-y-[-10vw]">
        <div class="absolute top-[15vw] left-[14vw] w-[30vw] h-[2vw] flex flex-col items-center">
            <img src="../../assets/img/Desktop/StartJourney/StartJourney.webp" alt="" class="w-full h-auto">
            <p class="text-white text-[0.83vw] font-league font-semibold text-center mt-[0.8vw]">Ready to embark on an epic hero’s journey? Download Idle Glory now and join the summoner’s
                community. Upgrade your squad, conquer challenges, and unleash your true power! Don’t miss out — victory
                awaits!
            </p>
            <img src="../../assets/img/Desktop/StartJourney/EnterAerthospng.webp" alt="" class="w-[7.4125vw] mt-[1.5vw] hover:cursor-pointer hover:opacity-80 duration-500 transition-all ease-in-out" @click="openWebLink('https://play.idle-glory.io/')">
            <div class="w-[21.3vw] flex flex-row justify-between mt-[1vw]">
                <div class="flex flex-row items-center hover:cursor-pointer">
                    <img src="../../assets/img/Desktop/StartJourney/Playstore.webp" alt="" class="w-[1.65vw] h-[1.875vw]">
                    <p class="font-league text-[1.25vw] font-black ml-[0.8vw] text-white">Google Play</p>
                </div>
                <div class="h-full w-[0.1vw] bg-white"></div>
                <div class="flex flex-row items-center hover:cursor-pointer">
                    <img src="../../assets/img/Desktop/StartJourney/Apple.webp" alt="" class="w-[1.65vw] h-[1.875vw]">
                    <p class="font-league text-[1.25vw] font-black ml-[0.8vw] text-white">App Store</p>
                </div>
            </div>
        </div>

        <!-- image iphone -->
        <div class="w-auto absolute top-[10vw] right-[13.65vw] flex flex-row items-center">
            <img src="../../assets/img/Desktop/StartJourney/3.webp" alt="" class="h-[24vw]">
            <img src="../../assets/img/Desktop/StartJourney/1.webp" alt="" class="h-[30vw]">
            <img src="../../assets/img/Desktop/StartJourney/2.webp" alt="" class="h-[24vw]">
        </div>

        <div class="absolute bottom-[2vw] w-full flex flex-col items-center">
            <img src="../../assets/img/Desktop/StartJourney/4.webp" alt="" class="w-[5.5vw]">
            <p class="text-white font-normal text-center text-[1.05vw] font-league mt-[2.5vw]">
                The ultimate turn-based tactical Idle RPG:<br/>
                Where strategy and perseverance transform you into a legend.
            </p>
            <div class="w-[10vw] h-[2vw] flex flex-row justify-between mt-[0.8vw]">
                <img src="../../assets/img/Desktop/StartJourney/Telegram.webp" alt="group" class="w-[2vw] h-[2vw] hover:cursor-pointer hover:scale-[1.2] transition-all duration-500 ease-in-out"
                @click="openWebLink('https://t.me/idleglory_group')">
                <img src="../../assets/img/Desktop/StartJourney/Telegram.webp" alt="channel" class="w-[2vw] h-[2vw] hover:cursor-pointer hover:scale-[1.2] transition-all duration-500 ease-in-out"
                @click="openWebLink('https://t.me/idleglory_channel')">
                <img src="../../assets/img/Desktop/StartJourney/prime_twitter.webp" alt="" class="w-[2vw] h-[2vw] hover:cursor-pointer hover:scale-[1.2] transition-all duration-500 ease-in-out"
                @click="openWebLink('https://x.com/idle_gIory')">
            </div>

            <div class="mt-[0.8vw] flex flex-row space-x-[3.6vw]">
                <p class="font-league text-[1.05vw] text-white hover:cursor-pointer font-black">
                    Story
                </p>
                <p class="font-league text-[1.05vw] text-white hover:cursor-pointer font-black">
                    Feature
                </p>
                <p class="font-league text-[1.05vw] text-white hover:cursor-pointer font-black">
                    Gameplay
                </p>
                <p class="font-league text-[1.05vw] text-white hover:cursor-pointer font-black">
                    Community
                </p>
                <p class="font-league text-[1.05vw] text-white hover:cursor-pointer font-black">
                    Contact
                </p>
                <p class="font-league text-[1.05vw] text-white hover:cursor-pointer font-black">
                    FAQs
                </p>
            </div>

            <p class="mt-[2.55vw] font-league text-[1.05vw] text-center font-semibold text-white">
                © 2025 Idle Glory. All rights reserved.
            </p>
        </div>
    </div>
</template>

<script setup>
function openWebLink(url) {
  setTimeout(() => {
    window.open(url, "_blank");
  }, 300);
}
</script>

<style scoped>
.font-emeritus {
    font-family: "Emeritus", sans-serif;
}

.font-league {
    font-family: "LeagueSpartan", sans-serif;
}
</style>